import useQueryParamState from "lib/queryParamState/useQueryParamState";
import { resetPagination } from "./usePaginationState";

type Publicness = "all" | "public" | "private";

export default function usePublicnessState() {
  return useQueryParamState<Publicness>(
    function getValue(query) {
      switch (query.publicness) {
        case "public":
        case "private":
          return query.publicness;
        default:
          return "all";
      }
    },

    function getQuery(publicness: Publicness) {
      const defaultValue = "all";

      if (publicness === defaultValue) {
        return { publicness: undefined };
      } else {
        return { publicness };
      }
    },

    {
      onChangeTransform: resetPagination,
    }
  );
}
